module.exports = __webpack_public_path__ + "static/img/glove_canard.ca5445d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_canard.png
// module id = eGna
// module chunks = 0